import { handleActions } from 'redux-actions';

import { Actions } from '../actions/currencies';

const initialState = {
  loading: false,
  error: null,
  value: [],
};

export default handleActions(
  {
    [Actions.CURRENCIES_REQUEST]: state => ({
      ...state,
      ...initialState,
      loading: true,
    }),
    [Actions.CURRENCIES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      error: null,
      value: action.response.result,
    }),
    [Actions.CURRENCIES_FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      value: [],
      error: action.error,
    }),
  },
  initialState
);
